import { Controller } from 'stimulus';

/**
 * Populates the shared "How is this calculated?" modal for the billing sheet
 * "More info" section. One modal is rendered per sheet; each automatically
 * calculated value has an info (ⓘ) trigger carrying `data-metric-title` and
 * `data-metric-body`. On `show.bs.modal` we copy those onto the modal's
 * heading + description, so a single modal serves every metric.
 */
export default class extends Controller {
  static targets = ['heading', 'description'];

  connect() {
    this.boundHandleShow = this.handleShow.bind(this);
    this.element.addEventListener('show.bs.modal', this.boundHandleShow);
  }

  disconnect() {
    this.element.removeEventListener('show.bs.modal', this.boundHandleShow);
  }

  handleShow(event) {
    const trigger = event.relatedTarget;
    if (!trigger || !trigger.dataset) return;

    if (this.hasHeadingTarget) {
      this.headingTarget.textContent = trigger.dataset.metricTitle || '';
    }
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent = trigger.dataset.metricBody || '';
    }
  }
}
